import "./styles.css";
import { useSelector, useDispatch } from "react-redux";
import {
  toggleFoodDetailModal,
  toggleOutOfServiceModal,
} from "../../redux/slices/appSlice";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faMinus, faPlus, faTimes } from "@fortawesome/free-solid-svg-icons";
import { RootState } from "../../redux/store";
import { addToCart, decrementQuantity } from "../../redux/slices/basketSlice";
import { IMAGES_BASE_URL } from "../../utils/useFetch";

const FoodDetailModal = () => {
  const dispatch = useDispatch();
  const selectedFood = useSelector(
    (state: RootState) => state.app.selectedFood
  );

  const basket = useSelector((state: RootState) => state.basket);
  const foodInCart = basket.cart.find(
    (item: any) => item.id === selectedFood.id
  );

  const isOutOfServiceTime = useSelector(
    (store: RootState) => store.app.isOutOfServiceTime
  );

  const isAppOutOfService = useSelector(
    (store: RootState) => store.app.isAppOutOfService
  );

  const onPlusClickHandle = (e: any) => {
    e.stopPropagation();

    if (isOutOfServiceTime || isAppOutOfService) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    dispatch(
      addToCart({
        ...selectedFood,
        quantity: foodInCart ? foodInCart.quantity : 1,
      })
    );
  };

  const onMinusClickHandle = () => {
    if (isOutOfServiceTime || isAppOutOfService) {
      dispatch(toggleOutOfServiceModal());
      return;
    }
    dispatch(decrementQuantity(selectedFood.id));
  };

  return (
    <div className='modal'>
      <div
        className='modal-background'
        onClick={() => dispatch(toggleFoodDetailModal())}
      ></div>
      <div className='modal-content'>
        <div className='box'>
          <div className='flex border-b'>
            <div className='flex-1 font-bold p-4'>{selectedFood.name}</div>
            <div>
              <button
                onClick={() => dispatch(toggleFoodDetailModal())}
                className='p-4'
                aria-label='close'
              >
                <FontAwesomeIcon icon={faTimes} />
              </button>
            </div>
          </div>

          <div>
            <img
              src={IMAGES_BASE_URL + selectedFood.image}
              onClick={() => dispatch(toggleFoodDetailModal())}
              className='block mx-auto'
              style={{ maxHeight: "280px" }}
              alt={selectedFood.name}
            />
          </div>
          <div className='p-2'>{selectedFood.description}</div>
          <div className='p-2 border-t'>
            <div className='mb-2'>روزهای سرو: </div>
            <div>
              <span
                className={`inline-block whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] font-bold leading-none ${
                  selectedFood.week_day.sat === 1
                    ? "text-green-700 bg-green-100"
                    : "text-gray-500 bg-gray-100"
                }  mr-1`}
              >
                شنبه
              </span>
              <span
                className={`inline-block whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] font-bold leading-none ${
                  selectedFood.week_day.sun === 1
                    ? "text-green-700 bg-green-100"
                    : "text-gray-500 bg-gray-100"
                }  mr-1`}
              >
                یکشنبه
              </span>
              <span
                className={`inline-block whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] font-bold leading-none ${
                  selectedFood.week_day.mon === 1
                    ? "text-green-700 bg-green-100"
                    : "text-gray-500 bg-gray-100"
                }  mr-1`}
              >
                دوشنبه
              </span>
              <span
                className={`inline-block whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] font-bold leading-none ${
                  selectedFood.week_day.tue === 1
                    ? "text-green-700 bg-green-100"
                    : "text-gray-500 bg-gray-100"
                }  mr-1`}
              >
                سه شنبه
              </span>
              <span
                className={`inline-block whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] font-bold leading-none ${
                  selectedFood.week_day.wed === 1
                    ? "text-green-700 bg-green-100"
                    : "text-gray-500 bg-gray-100"
                }  mr-1`}
              >
                چهار شنبه
              </span>
              <span
                className={`inline-block whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] font-bold leading-none ${
                  selectedFood.week_day.thu === 1
                    ? "text-green-700 bg-green-100"
                    : "text-gray-500 bg-gray-100"
                }  mr-1`}
              >
                پنج شنبه
              </span>
              <span
                className={`inline-block whitespace-nowrap rounded px-[0.5em] pt-[0.35em] pb-[0.25em] text-center align-baseline text-[0.75em] font-bold leading-none ${
                  selectedFood.week_day.fri === 1
                    ? "text-green-700 bg-green-100"
                    : "text-gray-500 bg-gray-100"
                }  mr-1`}
              >
                جمعه
              </span>
            </div>
          </div>
          <div className='p-2 border-t flex'>
            <div className='flex-1'>
              {selectedFood.day_meals_left === 0 && (
                <span className='px-2 inline-block text-gray-400 border rounded py-1'>
                  تمام شد!
                </span>
              )}

              {selectedFood.day_meals_left !== 0 && (
                <button
                  onClick={onPlusClickHandle}
                  className='px-3 py-1 h-[32px] rounded font-bold bg-rose-900 text-white'
                >
                  افزودن{" ("}
                  {new Intl.NumberFormat("fa-IR").format(selectedFood.price) +
                    " ریال)"}
                </button>
              )}
            </div>
            <div>
              <div className='flex'>
                {foodInCart && (
                  <span
                    className='bg-rose-900 rounded p-2  text-white h-8 inline-block'
                    onClick={onPlusClickHandle}
                  >
                    <FontAwesomeIcon icon={faPlus} />
                  </span>
                )}
                {foodInCart && (
                  <span className='px-2 h-8 inline-block flex items-center'>
                    {foodInCart.quantity}
                  </span>
                )}
                {foodInCart && (
                  <span
                    className='bg-gray-500 rounded p-2  text-white h-8 inline-block'
                    onClick={onMinusClickHandle}
                  >
                    <FontAwesomeIcon icon={faMinus} />
                  </span>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FoodDetailModal;
